// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Invite users — mobile-first shell
   Fixes right-edge clipping with min-width:0 / max-width:100% / overflow guards. */

.invite-shell {
  --invite-ink: var(--brand-text, #0f172a);
  --invite-muted: var(--brand-text-secondary, #64748b);
  --invite-accent: var(--brand-primary, #0877bc);
  --invite-accent-rgb: var(--brand-primary-rgb, 8, 119, 188);
  --invite-surface: color-mix(in srgb, var(--brand-surface, #fff) 92%, transparent);
  --invite-ease: cubic-bezier(0.25, 1, 0.5, 1);

  position: relative;
  isolation: isolate;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0 auto;
  padding:
    max(0.75rem, env(safe-area-inset-top, 0px))
    max(1rem, env(safe-area-inset-right, 0px))
    calc(7.5rem + env(safe-area-inset-bottom, 0px))
    max(1rem, env(safe-area-inset-left, 0px));
  overflow-x: clip;
  color: var(--invite-ink);
}

.invite-shell *,
.invite-shell *::before,
.invite-shell *::after {
  box-sizing: border-box;
}

.invite-shell__glow {
  pointer-events: none;
  position: absolute;
  z-index: -1;
  inset: -10% -20% auto;
  height: 280px;
  background:
    radial-gradient(
      55% 70% at 12% 20%,
      rgba(var(--invite-accent-rgb), 0.22) 0%,
      transparent 70%
    ),
    radial-gradient(
      45% 60% at 88% 0%,
      rgba(14, 165, 233, 0.14) 0%,
      transparent 68%
    );
  filter: blur(2px);
  animation: invite-glow-drift 10s var(--invite-ease) infinite alternate;
}

@keyframes invite-glow-drift {
  from {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 0.9;
  }
  to {
    transform: translate3d(2%, 3%, 0) scale(1.04);
    opacity: 1;
  }
}

/* —— Hero —— */
.invite-hero {
  margin-bottom: 1.1rem;
  animation: invite-rise 0.55s var(--invite-ease) both;
}

.invite-hero__brand {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  min-width: 0;
}

.invite-hero__logo {
  flex: 0 0 auto;
  width: 56px;
  height: 56px;
  object-fit: contain;
  border-radius: 16px;
  padding: 6px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(var(--invite-accent-rgb), 0.14);
  box-shadow: 0 10px 28px -16px rgba(15, 23, 42, 0.35);
}

.invite-hero__copy {
  min-width: 0;
  flex: 1 1 auto;
}

.invite-hero__eyebrow {
  margin: 0 0 0.15rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--invite-accent);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.invite-hero__title {
  margin: 0;
  font-size: clamp(1.55rem, 6.5vw, 2rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.15;
  color: var(--invite-ink);
}

.invite-hero__sub {
  margin: 0.35rem 0 0;
  font-size: 0.92rem;
  line-height: 1.45;
  color: var(--invite-muted);
  max-width: 36ch;
}

/* —— Method switcher (Link / Email / QR) —— */
.invite-methods {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.45rem;
  margin-bottom: 0.9rem;
  padding: 0.35rem;
  border-radius: 16px;
  background: rgba(var(--invite-accent-rgb), 0.08);
  border: 1px solid rgba(var(--invite-accent-rgb), 0.12);
  animation: invite-rise 0.5s var(--invite-ease) both;
}

.invite-methods__tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-width: 0;
  min-height: 44px;
  padding: 0.55rem 0.45rem;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: var(--invite-muted);
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  transition:
    transform 0.25s var(--invite-ease),
    background 0.25s ease,
    color 0.25s ease,
    box-shadow 0.25s ease;
}

.invite-methods__tab span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.invite-methods__tab:active {
  transform: scale(0.97);
}

.invite-methods__tab.is-active {
  color: #fff;
  background: linear-gradient(
    135deg,
    var(--invite-accent) 0%,
    color-mix(in srgb, var(--invite-accent) 72%, #0ea5e9) 100%
  );
  box-shadow: 0 10px 22px -12px rgba(var(--invite-accent-rgb), 0.75);
}

.invite-methods__tab:focus-visible {
  outline: 2px solid var(--invite-accent);
  outline-offset: 2px;
}

/* —— QR panel —— */
.invite-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  min-width: 0;
}

.invite-qr__frame {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-radius: 18px;
  background: #fff;
  border: 1px solid rgba(var(--invite-accent-rgb), 0.16);
  box-shadow: 0 12px 28px -18px rgba(15, 23, 42, 0.35);
}

.invite-qr__frame canvas {
  display: block;
  max-width: 100%;
  height: auto;
}

.invite-qr .invite-share__url {
  width: 100%;
  text-align: center;
}

.invite-qr__actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.55rem;
  width: 100%;
}

/* —— Panels —— */
.invite-panel {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin-bottom: 0.9rem;
  padding: 1.05rem 1.05rem 1.15rem;
  border-radius: 20px;
  background: var(--invite-surface);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid rgba(var(--invite-accent-rgb), 0.12);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.55) inset,
    0 14px 36px -22px rgba(15, 23, 42, 0.28);
  animation: invite-rise 0.6s var(--invite-ease) both;
}

.invite-panel--primary {
  animation-delay: 0.06s;
}

.invite-panel__head {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  min-width: 0;
  margin-bottom: 0.95rem;
}

.invite-panel__icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  color: var(--invite-accent);
  background: rgba(var(--invite-accent-rgb), 0.1);
}

.invite-panel__title {
  margin: 0 0 0.25rem;
  font-size: 1.02rem;
  font-weight: 750;
  letter-spacing: -0.02em;
  color: var(--invite-ink);
}

.invite-panel__hint {
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.45;
  color: var(--invite-muted);
  overflow-wrap: anywhere;
}

/* —— Share link —— */
.invite-share {
  display: grid;
  gap: 0.7rem;
  min-width: 0;
}

.invite-share__url {
  margin: 0;
  min-width: 0;
  max-width: 100%;
  padding: 0.75rem 0.85rem;
  border-radius: 14px;
  font-size: 0.82rem;
  line-height: 1.4;
  color: var(--invite-ink);
  background: rgba(var(--invite-accent-rgb), 0.06);
  border: 1px dashed rgba(var(--invite-accent-rgb), 0.28);
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* —— Role chips (horizontal scroll on narrow screens) —— */
.invite-roles {
  display: flex;
  gap: 0.5rem;
  margin: 0 0 1rem;
  padding: 0.15rem 0.1rem 0.35rem;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  max-width: 100%;
}

.invite-roles::-webkit-scrollbar {
  display: none;
}

.invite-roles__chip {
  flex: 0 0 auto;
  scroll-snap-align: start;
  min-height: 40px;
  padding: 0.55rem 0.95rem;
  border-radius: 999px;
  border: 1px solid rgba(var(--invite-accent-rgb), 0.22);
  background: rgba(255, 255, 255, 0.55);
  color: var(--invite-ink);
  font-size: 0.84rem;
  font-weight: 650;
  white-space: nowrap;
  cursor: pointer;
  transition:
    transform 0.25s var(--invite-ease),
    background 0.25s ease,
    color 0.25s ease,
    border-color 0.25s ease,
    box-shadow 0.25s ease;
}

.invite-roles__chip:active {
  transform: scale(0.97);
}

.invite-roles__chip.is-active {
  color: #fff;
  background: linear-gradient(
    135deg,
    var(--invite-accent) 0%,
    color-mix(in srgb, var(--invite-accent) 72%, #0ea5e9) 100%
  );
  border-color: transparent;
  box-shadow: 0 10px 22px -12px rgba(var(--invite-accent-rgb), 0.75);
}

.invite-roles__chip:focus-visible,
.invite-btn:focus-visible,
.invite-field input:focus-visible {
  outline: 2px solid var(--invite-accent);
  outline-offset: 2px;
}

/* —— Form —— */
.invite-form {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  min-width: 0;
  width: 100%;
}

.invite-fields-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.85rem;
  min-width: 0;
}

.invite-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}

.invite-field > span {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--invite-muted);
}

.invite-field input {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 48px;
  padding: 0.7rem 0.9rem;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: rgba(255, 255, 255, 0.78);
  color: var(--invite-ink);
  font-size: 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.invite-field input::placeholder {
  color: #94a3b8;
}

.invite-field input:focus {
  border-color: var(--invite-accent);
  background: #fff;
  box-shadow: 0 0 0 4px rgba(var(--invite-accent-rgb), 0.14);
}

.invite-error {
  margin: 0;
  padding: 0.65rem 0.8rem;
  border-radius: 12px;
  font-size: 0.86rem;
  line-height: 1.4;
  color: #b91c1c;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.22);
  overflow-wrap: anywhere;
}

/* —— Buttons —— */
.invite-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 48px;
  width: 100%;
  max-width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 14px;
  border: none;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition:
    transform 0.25s var(--invite-ease),
    box-shadow 0.25s ease,
    background 0.25s ease,
    opacity 0.2s ease;
}

.invite-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.invite-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.invite-btn--primary {
  color: #fff;
  background: linear-gradient(
    135deg,
    var(--invite-accent) 0%,
    color-mix(in srgb, var(--invite-accent) 70%, #0369a1) 100%
  );
  box-shadow: 0 14px 28px -14px rgba(var(--invite-accent-rgb), 0.8);
}

.invite-btn--primary:hover:not(:disabled) {
  transform: translateY(-1px) scale(1.01);
  box-shadow: 0 18px 32px -14px rgba(var(--invite-accent-rgb), 0.9);
}

.invite-btn--ghost {
  color: var(--invite-accent);
  background: rgba(var(--invite-accent-rgb), 0.08);
  border: 1px solid rgba(var(--invite-accent-rgb), 0.22);
}

.invite-btn--ghost.is-copied {
  color: #047857;
  background: rgba(16, 185, 129, 0.12);
  border-color: rgba(16, 185, 129, 0.35);
}

@keyframes invite-rise {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* —— Wider phones / tablet —— */
@media (min-width: 480px) {
  .invite-fields-row {
    grid-template-columns: 1fr 1fr;
  }

  .invite-share {
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: stretch;
  }

  .invite-share .invite-btn--ghost {
    width: auto;
    padding-inline: 1.1rem;
  }

  .invite-qr__actions {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .invite-methods__tab {
    font-size: 0.88rem;
    padding-inline: 0.65rem;
  }
}

@media (min-width: 720px) {
  .invite-shell {
    max-width: 640px;
    padding-top: 1.25rem;
    padding-inline: 1.25rem;
  }

  .invite-panel {
    padding: 1.25rem 1.35rem 1.4rem;
  }

  .invite-roles {
    flex-wrap: wrap;
    overflow: visible;
  }

  .invite-roles__chip {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(25% - 0.5rem);
    text-align: center;
    justify-content: center;
  }
}

/* Dark theme */
:root[data-theme="dark"] .invite-shell,
.theme-dark .invite-shell,
body.dark .invite-shell {
  --invite-ink: #f1f5f9;
  --invite-muted: #94a3b8;
  --invite-surface: rgba(30, 41, 59, 0.72);
}

:root[data-theme="dark"] .invite-hero__logo,
.theme-dark .invite-hero__logo,
body.dark .invite-hero__logo {
  background: rgba(15, 23, 42, 0.75);
}

:root[data-theme="dark"] .invite-field input,
.theme-dark .invite-field input,
body.dark .invite-field input {
  background: rgba(15, 23, 42, 0.65);
  border-color: rgba(148, 163, 184, 0.28);
  color: #f8fafc;
}

:root[data-theme="dark"] .invite-roles__chip,
.theme-dark .invite-roles__chip,
body.dark .invite-roles__chip {
  background: rgba(15, 23, 42, 0.55);
  color: #e2e8f0;
}

:root[data-theme="dark"] .invite-methods,
.theme-dark .invite-methods,
body.dark .invite-methods {
  background: rgba(15, 23, 42, 0.45);
}

:root[data-theme="dark"] .invite-qr__frame,
.theme-dark .invite-qr__frame,
body.dark .invite-qr__frame {
  background: #fff;
}

/* Admin shell: stop horizontal bleed that clips the right edge on mobile */
.main-content-with-bottom-nav #dashboard.admin-theme-root {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: clip;
}

.main-content-with-bottom-nav #content {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.main-content-with-bottom-nav #content .invite-shell {
  /* Override legacy .title / dashboard padding collisions */
  margin-left: 0;
  margin-right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminLayout/InviteUser.css"],"names":[],"mappings":"AAAA;mFACmF;;AAEnF;EACE,wCAAwC;EACxC,oDAAoD;EACpD,8CAA8C;EAC9C,0DAA0D;EAC1D,iFAAiF;EACjF,4CAA4C;;EAE5C,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd;;;;6CAI2C;EAC3C,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb;;;;;;;;;;KAUG;EACH,iBAAiB;EACjB,sEAAsE;AACxE;;AAEA;EACE;IACE,wCAAwC;IACxC,YAAY;EACd;EACA;IACE,6CAA6C;IAC7C,UAAU;EACZ;AACF;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;EACrC,sDAAsD;EACtD,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;EAChD,sDAAsD;EACtD,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;;;yBAIuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX;;;;GAIC;EACD,kEAAkE;AACpE;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sDAAsD;EACtD,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,sDAAsD;EACtD;;4CAE0C;EAC1C,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gDAAgD;EAChD,uDAAuD;EACvD,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,sDAAsD;EACtD,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf;;;;;yBAKuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX;;;;GAIC;EACD,yBAAyB;EACzB,kEAAkE;AACpE;;AAEA;;;EAGE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;;;qBAImB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX;;;;GAIC;EACD,iEAAiE;AACnE;;AAEA;EACE,uCAAuC;EACvC,iEAAiE;AACnE;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,0CAA0C;IAC1C,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAA4B;IAA5B,cAA4B;IAA5B,8BAA4B;IAC5B,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA,eAAe;AACf;;;EAGE,qBAAqB;EACrB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;;;EAGE,kCAAkC;EAClC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;;;EAGE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0DAA0D;EAC1D,cAAc;EACd,eAAe;AACjB","sourcesContent":["/* Invite users — mobile-first shell\n   Fixes right-edge clipping with min-width:0 / max-width:100% / overflow guards. */\n\n.invite-shell {\n  --invite-ink: var(--brand-text, #0f172a);\n  --invite-muted: var(--brand-text-secondary, #64748b);\n  --invite-accent: var(--brand-primary, #0877bc);\n  --invite-accent-rgb: var(--brand-primary-rgb, 8, 119, 188);\n  --invite-surface: color-mix(in srgb, var(--brand-surface, #fff) 92%, transparent);\n  --invite-ease: cubic-bezier(0.25, 1, 0.5, 1);\n\n  position: relative;\n  isolation: isolate;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0 auto;\n  padding:\n    max(0.75rem, env(safe-area-inset-top, 0px))\n    max(1rem, env(safe-area-inset-right, 0px))\n    calc(7.5rem + env(safe-area-inset-bottom, 0px))\n    max(1rem, env(safe-area-inset-left, 0px));\n  overflow-x: clip;\n  color: var(--invite-ink);\n}\n\n.invite-shell *,\n.invite-shell *::before,\n.invite-shell *::after {\n  box-sizing: border-box;\n}\n\n.invite-shell__glow {\n  pointer-events: none;\n  position: absolute;\n  z-index: -1;\n  inset: -10% -20% auto;\n  height: 280px;\n  background:\n    radial-gradient(\n      55% 70% at 12% 20%,\n      rgba(var(--invite-accent-rgb), 0.22) 0%,\n      transparent 70%\n    ),\n    radial-gradient(\n      45% 60% at 88% 0%,\n      rgba(14, 165, 233, 0.14) 0%,\n      transparent 68%\n    );\n  filter: blur(2px);\n  animation: invite-glow-drift 10s var(--invite-ease) infinite alternate;\n}\n\n@keyframes invite-glow-drift {\n  from {\n    transform: translate3d(0, 0, 0) scale(1);\n    opacity: 0.9;\n  }\n  to {\n    transform: translate3d(2%, 3%, 0) scale(1.04);\n    opacity: 1;\n  }\n}\n\n/* —— Hero —— */\n.invite-hero {\n  margin-bottom: 1.1rem;\n  animation: invite-rise 0.55s var(--invite-ease) both;\n}\n\n.invite-hero__brand {\n  display: flex;\n  align-items: center;\n  gap: 0.9rem;\n  min-width: 0;\n}\n\n.invite-hero__logo {\n  flex: 0 0 auto;\n  width: 56px;\n  height: 56px;\n  object-fit: contain;\n  border-radius: 16px;\n  padding: 6px;\n  background: rgba(255, 255, 255, 0.72);\n  border: 1px solid rgba(var(--invite-accent-rgb), 0.14);\n  box-shadow: 0 10px 28px -16px rgba(15, 23, 42, 0.35);\n}\n\n.invite-hero__copy {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.invite-hero__eyebrow {\n  margin: 0 0 0.15rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--invite-accent);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.invite-hero__title {\n  margin: 0;\n  font-size: clamp(1.55rem, 6.5vw, 2rem);\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.15;\n  color: var(--invite-ink);\n}\n\n.invite-hero__sub {\n  margin: 0.35rem 0 0;\n  font-size: 0.92rem;\n  line-height: 1.45;\n  color: var(--invite-muted);\n  max-width: 36ch;\n}\n\n/* —— Method switcher (Link / Email / QR) —— */\n.invite-methods {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.45rem;\n  margin-bottom: 0.9rem;\n  padding: 0.35rem;\n  border-radius: 16px;\n  background: rgba(var(--invite-accent-rgb), 0.08);\n  border: 1px solid rgba(var(--invite-accent-rgb), 0.12);\n  animation: invite-rise 0.5s var(--invite-ease) both;\n}\n\n.invite-methods__tab {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-width: 0;\n  min-height: 44px;\n  padding: 0.55rem 0.45rem;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: var(--invite-muted);\n  font-size: 0.82rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition:\n    transform 0.25s var(--invite-ease),\n    background 0.25s ease,\n    color 0.25s ease,\n    box-shadow 0.25s ease;\n}\n\n.invite-methods__tab span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.invite-methods__tab:active {\n  transform: scale(0.97);\n}\n\n.invite-methods__tab.is-active {\n  color: #fff;\n  background: linear-gradient(\n    135deg,\n    var(--invite-accent) 0%,\n    color-mix(in srgb, var(--invite-accent) 72%, #0ea5e9) 100%\n  );\n  box-shadow: 0 10px 22px -12px rgba(var(--invite-accent-rgb), 0.75);\n}\n\n.invite-methods__tab:focus-visible {\n  outline: 2px solid var(--invite-accent);\n  outline-offset: 2px;\n}\n\n/* —— QR panel —— */\n.invite-qr {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.85rem;\n  min-width: 0;\n}\n\n.invite-qr__frame {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  border-radius: 18px;\n  background: #fff;\n  border: 1px solid rgba(var(--invite-accent-rgb), 0.16);\n  box-shadow: 0 12px 28px -18px rgba(15, 23, 42, 0.35);\n}\n\n.invite-qr__frame canvas {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n.invite-qr .invite-share__url {\n  width: 100%;\n  text-align: center;\n}\n\n.invite-qr__actions {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.55rem;\n  width: 100%;\n}\n\n/* —— Panels —— */\n.invite-panel {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin-bottom: 0.9rem;\n  padding: 1.05rem 1.05rem 1.15rem;\n  border-radius: 20px;\n  background: var(--invite-surface);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n  border: 1px solid rgba(var(--invite-accent-rgb), 0.12);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.55) inset,\n    0 14px 36px -22px rgba(15, 23, 42, 0.28);\n  animation: invite-rise 0.6s var(--invite-ease) both;\n}\n\n.invite-panel--primary {\n  animation-delay: 0.06s;\n}\n\n.invite-panel__head {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  min-width: 0;\n  margin-bottom: 0.95rem;\n}\n\n.invite-panel__icon {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  color: var(--invite-accent);\n  background: rgba(var(--invite-accent-rgb), 0.1);\n}\n\n.invite-panel__title {\n  margin: 0 0 0.25rem;\n  font-size: 1.02rem;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  color: var(--invite-ink);\n}\n\n.invite-panel__hint {\n  margin: 0;\n  font-size: 0.84rem;\n  line-height: 1.45;\n  color: var(--invite-muted);\n  overflow-wrap: anywhere;\n}\n\n/* —— Share link —— */\n.invite-share {\n  display: grid;\n  gap: 0.7rem;\n  min-width: 0;\n}\n\n.invite-share__url {\n  margin: 0;\n  min-width: 0;\n  max-width: 100%;\n  padding: 0.75rem 0.85rem;\n  border-radius: 14px;\n  font-size: 0.82rem;\n  line-height: 1.4;\n  color: var(--invite-ink);\n  background: rgba(var(--invite-accent-rgb), 0.06);\n  border: 1px dashed rgba(var(--invite-accent-rgb), 0.28);\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n/* —— Role chips (horizontal scroll on narrow screens) —— */\n.invite-roles {\n  display: flex;\n  gap: 0.5rem;\n  margin: 0 0 1rem;\n  padding: 0.15rem 0.1rem 0.35rem;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  scroll-snap-type: x proximity;\n  scrollbar-width: none;\n  max-width: 100%;\n}\n\n.invite-roles::-webkit-scrollbar {\n  display: none;\n}\n\n.invite-roles__chip {\n  flex: 0 0 auto;\n  scroll-snap-align: start;\n  min-height: 40px;\n  padding: 0.55rem 0.95rem;\n  border-radius: 999px;\n  border: 1px solid rgba(var(--invite-accent-rgb), 0.22);\n  background: rgba(255, 255, 255, 0.55);\n  color: var(--invite-ink);\n  font-size: 0.84rem;\n  font-weight: 650;\n  white-space: nowrap;\n  cursor: pointer;\n  transition:\n    transform 0.25s var(--invite-ease),\n    background 0.25s ease,\n    color 0.25s ease,\n    border-color 0.25s ease,\n    box-shadow 0.25s ease;\n}\n\n.invite-roles__chip:active {\n  transform: scale(0.97);\n}\n\n.invite-roles__chip.is-active {\n  color: #fff;\n  background: linear-gradient(\n    135deg,\n    var(--invite-accent) 0%,\n    color-mix(in srgb, var(--invite-accent) 72%, #0ea5e9) 100%\n  );\n  border-color: transparent;\n  box-shadow: 0 10px 22px -12px rgba(var(--invite-accent-rgb), 0.75);\n}\n\n.invite-roles__chip:focus-visible,\n.invite-btn:focus-visible,\n.invite-field input:focus-visible {\n  outline: 2px solid var(--invite-accent);\n  outline-offset: 2px;\n}\n\n/* —— Form —— */\n.invite-form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  min-width: 0;\n  width: 100%;\n}\n\n.invite-fields-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.85rem;\n  min-width: 0;\n}\n\n.invite-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.invite-field > span {\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--invite-muted);\n}\n\n.invite-field input {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 48px;\n  padding: 0.7rem 0.9rem;\n  border-radius: 14px;\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  background: rgba(255, 255, 255, 0.78);\n  color: var(--invite-ink);\n  font-size: 1rem;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n\n.invite-field input::placeholder {\n  color: #94a3b8;\n}\n\n.invite-field input:focus {\n  border-color: var(--invite-accent);\n  background: #fff;\n  box-shadow: 0 0 0 4px rgba(var(--invite-accent-rgb), 0.14);\n}\n\n.invite-error {\n  margin: 0;\n  padding: 0.65rem 0.8rem;\n  border-radius: 12px;\n  font-size: 0.86rem;\n  line-height: 1.4;\n  color: #b91c1c;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.22);\n  overflow-wrap: anywhere;\n}\n\n/* —— Buttons —— */\n.invite-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  min-height: 48px;\n  width: 100%;\n  max-width: 100%;\n  padding: 0.75rem 1rem;\n  border-radius: 14px;\n  border: none;\n  font-size: 0.95rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition:\n    transform 0.25s var(--invite-ease),\n    box-shadow 0.25s ease,\n    background 0.25s ease,\n    opacity 0.2s ease;\n}\n\n.invite-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.invite-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.invite-btn--primary {\n  color: #fff;\n  background: linear-gradient(\n    135deg,\n    var(--invite-accent) 0%,\n    color-mix(in srgb, var(--invite-accent) 70%, #0369a1) 100%\n  );\n  box-shadow: 0 14px 28px -14px rgba(var(--invite-accent-rgb), 0.8);\n}\n\n.invite-btn--primary:hover:not(:disabled) {\n  transform: translateY(-1px) scale(1.01);\n  box-shadow: 0 18px 32px -14px rgba(var(--invite-accent-rgb), 0.9);\n}\n\n.invite-btn--ghost {\n  color: var(--invite-accent);\n  background: rgba(var(--invite-accent-rgb), 0.08);\n  border: 1px solid rgba(var(--invite-accent-rgb), 0.22);\n}\n\n.invite-btn--ghost.is-copied {\n  color: #047857;\n  background: rgba(16, 185, 129, 0.12);\n  border-color: rgba(16, 185, 129, 0.35);\n}\n\n@keyframes invite-rise {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* —— Wider phones / tablet —— */\n@media (min-width: 480px) {\n  .invite-fields-row {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .invite-share {\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: stretch;\n  }\n\n  .invite-share .invite-btn--ghost {\n    width: auto;\n    padding-inline: 1.1rem;\n  }\n\n  .invite-qr__actions {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .invite-methods__tab {\n    font-size: 0.88rem;\n    padding-inline: 0.65rem;\n  }\n}\n\n@media (min-width: 720px) {\n  .invite-shell {\n    max-width: 640px;\n    padding-top: 1.25rem;\n    padding-inline: 1.25rem;\n  }\n\n  .invite-panel {\n    padding: 1.25rem 1.35rem 1.4rem;\n  }\n\n  .invite-roles {\n    flex-wrap: wrap;\n    overflow: visible;\n  }\n\n  .invite-roles__chip {\n    flex: 1 1 calc(25% - 0.5rem);\n    text-align: center;\n    justify-content: center;\n  }\n}\n\n/* Dark theme */\n:root[data-theme=\"dark\"] .invite-shell,\n.theme-dark .invite-shell,\nbody.dark .invite-shell {\n  --invite-ink: #f1f5f9;\n  --invite-muted: #94a3b8;\n  --invite-surface: rgba(30, 41, 59, 0.72);\n}\n\n:root[data-theme=\"dark\"] .invite-hero__logo,\n.theme-dark .invite-hero__logo,\nbody.dark .invite-hero__logo {\n  background: rgba(15, 23, 42, 0.75);\n}\n\n:root[data-theme=\"dark\"] .invite-field input,\n.theme-dark .invite-field input,\nbody.dark .invite-field input {\n  background: rgba(15, 23, 42, 0.65);\n  border-color: rgba(148, 163, 184, 0.28);\n  color: #f8fafc;\n}\n\n:root[data-theme=\"dark\"] .invite-roles__chip,\n.theme-dark .invite-roles__chip,\nbody.dark .invite-roles__chip {\n  background: rgba(15, 23, 42, 0.55);\n  color: #e2e8f0;\n}\n\n:root[data-theme=\"dark\"] .invite-methods,\n.theme-dark .invite-methods,\nbody.dark .invite-methods {\n  background: rgba(15, 23, 42, 0.45);\n}\n\n:root[data-theme=\"dark\"] .invite-qr__frame,\n.theme-dark .invite-qr__frame,\nbody.dark .invite-qr__frame {\n  background: #fff;\n}\n\n/* Admin shell: stop horizontal bleed that clips the right edge on mobile */\n.main-content-with-bottom-nav #dashboard.admin-theme-root {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: clip;\n}\n\n.main-content-with-bottom-nav #content {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.main-content-with-bottom-nav #content .invite-shell {\n  /* Override legacy .title / dashboard padding collisions */\n  margin-left: 0;\n  margin-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
